import plugin from 'tailwindcss/plugin';

var componentsPlugin = plugin(function (_ref) {
  var addBase = _ref.addBase;
  addBase({
    ':is(.csg-tw-checkbox[data-selected],.csg-tw-checkbox[data-indeterminate]) svg': {
      strokeDashoffset: '44px'
    },
    ':is(.csg-tw-checkbox[data-indeterminate]) svg': {
      stroke: 'none',
      fill: 'currentColor'
    }
  });
});

export { componentsPlugin as default };
//# sourceMappingURL=components-plugin.esm.js.map
